import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './PageHeader.module.scss';
import EmailLoginDialog from '../Auth/EmailLoginDialog';

const PageHeader = () => {
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <>
      <header className={styles.appHeader}>
        <nav className={styles.navbar}>
          <Link to="/" className={styles.navbarBrand}>
            CROSSOVER GRID
          </Link>
          <div className={styles.navLinks}>
            <button 
              onClick={() => setLoginOpen(true)} 
              className={styles.navLink}
            >
              Sign In
            </button>
          </div>
        </nav>
      </header>
      
      <EmailLoginDialog 
        open={loginOpen} 
        onClose={() => setLoginOpen(false)} 
      />
    </>
  );
};

export default PageHeader;
